import React from 'react';
import { Link, Location } from 'react-router-dom';

export default function NoAccess () {
    return (
        <div className="wrapper wrapper-content">
            <div className="middle-box text-center">
                <h3 className="font-bold">Sorry, you can't access this</h3>
                <div className="error-desc">
                    Either this page no longer exists or you need different Role or Project permissions to access this area.
                    <br/><a href="/main" className="btn btn-primary m-t">Home</a>
                </div>
            </div>
        </div>
    )
};
